export default __webpack_public_path__ + "static/media/iconn3.642cc0af.svg";